import { Component } from '@angular/core';

@Component({
  selector: 'app-project-not-active',
  templateUrl: './project-not-active.component.html',
  styleUrls: ['./project-not-active.component.sass']
})
export class ProjectNotActiveComponent {

}
